import { defineMessage } from '@lingui/macro';

const SUPER_ADMIN = 'SUPER_ADMIN',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  FOREMAN = 'FOREMAN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  SUPER_USER = 'SUPER_USER',
  ROD_ROOM_ATTENDANT = 'ROD_ROOM_ATTENDANT';

export const PersonaMessages = {
  [SUPER_ADMIN]: defineMessage({ message: 'Super Admin', id: 'SUPER_ADMIN' }),
  [SUPERINTENDENT]: defineMessage({ message: 'Superintendent', id: 'SUPERINTENDENT' }),
  [FIELD_ENGINEER]: defineMessage({ message: 'Field Engineer', id: 'FIELD_ENGINEER' }),
  [FOREMAN]: defineMessage({ message: 'Foreman', id: 'FOREMAN' }),
  [GENERAL_FOREMAN]: defineMessage({ message: 'General Foreman', id: 'GENERAL_FOREMAN' }),
  [PROJECT_ADMIN]: defineMessage({ message: 'Project Admin', id: 'PROJECT_ADMIN' }),
  [SUPER_USER]: defineMessage({ message: 'Super User', id: 'SUPER_USER' }),
  [ROD_ROOM_ATTENDANT]: defineMessage({ message: 'Rod Room Attendant', id: 'ROD_ROOM_ATTENDANT' }),
};
